<script>
export default {
    name: 'ForgotPassword',
    components: {}
}
</script>

<template>
    <b-container>
        <b-row>
            <b-col lg="6" offset-lg="3" class="mt-5">
                <b-card header="Page non trouvée">
                    Désolé, la page que vous recherchez est introuvable.
                    <template #footer>
                        <b-button size="sm" variant="secondary" :to="{ name: 'dashboard' }">Retourner à l'accueil</b-button>
                    </template>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>